// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"88af9de51ad4aa54","8463":"1003b5fb58552ca4","9862":"1003b5fb58552ca4"}[chunkId] + ".css";
};